import * as React from "react";
import { Container } from "reactstrap";
import { QnaRelease } from "./qna-release";
import { getAsync } from "../utils/net";
import { Environment } from "../models/environment";
import { NluRelease } from "./nlu-release";
import { DialogsRelease } from "./dialogs-release";
import "./release-management.css";

type ReleaseManagerType = "qna" | "dialogs" | "nlu";

export interface ReleaseManagementProps { }
export interface ReleaseManagementState {
    environments: Environment[],
    channels: string[]
    currentManagerType: ReleaseManagerType
}

export class ReleaseManagement extends React.Component<
    ReleaseManagementProps,
    ReleaseManagementState
    > {

    constructor(props: ReleaseManagementProps) {
        super(props);

        this.state = {
            environments: [],
            channels: [],
            currentManagerType: "dialogs"
        }
    }

    async componentWillMount() {
        await this.getEnvironmentsAsync();
        await this.getChannelsAsync();
    }

    private async getEnvironmentsAsync() {
        try {
            const response = await getAsync("/api/ReleaseManagement/environments");
            if (!response.ok) {
                throw Error(response.statusText);
            }

            const environments: Environment[] = await response.json();

            if (environments) {
                this.setState({
                    environments: environments
                });
            } else {
                throw Error("Error retrieving environments");
            }

        } catch (error) {
            // avoid logging error details for the sake of security
            console.log("Error retrieving release environments");
        }
    }

    private async getChannelsAsync() {
        try {
            const response = await getAsync("/api/ReleaseManagement/channels");
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const channels: string[] = await response.json();
            if (channels) {
                this.setState({
                    channels: channels
                });
            } else {
                throw Error("Error retrieving release channels");
            }
        } catch (error) {
            // avoid logging error details for the sake of security
            console.log("Error retrieving release channels");
        }
    }

    render() {
        return (
            <Container fluid={true} className="page">
                {this.state.environments && this.state.environments.length > 0 &&
                    (<div>
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    onClick={() => this.setState({ currentManagerType: "dialogs" })}
                                >
                                    Dialogs
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" onClick={() => this.setState({ currentManagerType: "nlu" })}>
                                    NLU</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" onClick={() => this.setState({ currentManagerType: "qna" })}>
                                    QnA</a>
                            </li>
                        </ul>
                        {this.showReleaseManager()}
                    </div>)}
            </Container>);
    }

    private showReleaseManager() {
        switch (this.state.currentManagerType) {
            case "qna":
                return <QnaRelease environments={this.state.environments} channels={this.state.channels} />;
            case "dialogs":
                return <DialogsRelease environments={this.state.environments} />;
            case "nlu":
                return <NluRelease environments={this.state.environments} />;
            default:
                return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/release-management/release-management.tsx